/* Destination désactivée par Build my reviews — DS-07 (Bible §20 · ADM-08).
   Reserved for genuine legal/security/technical necessity. Status, reason,
   time and audit are visible to merchant and customer; declared fallbacks
   take over automatically. Natural in the everything-wrong world;
   ?etat=en-cours renders it from any world. */
import { useSearchParams } from 'react-router-dom'
import { Button, EmptyState, ErrorState, KV, Note } from '@/ui'
import { useEmergencyDisable, type EmergencyDisable } from './api'
import { Chargement, Retour } from './parts'

const DESSINE: EmergencyDisable = {
  destination: 'Trustpilot',
  reason: 'exigence légale/technique vérifiée',
  since: '29 août, 09:14 · statut visible client & marchand',
  fallback: 'basculées sur leur repli déclaré',
  reactivation: 'annoncée ici, avec re-confirmation demandée',
}

export default function Desactivee() {
  const { data, isPending, isError, refetch } = useEmergencyDisable()
  const [params] = useSearchParams()

  if (isPending) return <Chargement />
  if (isError) return (
    <ErrorState what="Impossible de charger l’état de vos liens d’avis."
      action={<Button variant="primary" size="sm" onClick={() => refetch()}>Réessayer</Button>} />
  )

  const d = params.get('etat') === 'en-cours' ? DESSINE : data.current
  if (!d) return (
    <div style={{ display: 'grid', gap: 16, maxWidth: 620 }}>
      <Retour />
      <EmptyState title="Aucun lien d’avis désactivé."
        why="Une désactivation d’urgence est annoncée ici, avec sa raison et son heure. Il n’y en a aucune en cours." />
    </div>
  )

  return (
    <div style={{ display: 'grid', gap: 16, maxWidth: 640 }}>
      <Retour />
      <h2 className="t-page" style={{ margin: 0 }}>Lien d’avis désactivé par Build my reviews</h2>

      <Note tone="crit">
        <b>✕ {d.destination} est temporairement désactivée pour tous les comptes —
        raison&nbsp;: {d.reason}.</b>
      </Note>

      <KV rows={[
        ['Depuis', d.since],
        ['Vos campagnes', d.fallback],
        ['Réactivation', d.reactivation],
      ]} />

      <p className="f-help" style={{ margin: 0 }}>
        Jamais utilisée comme dégradation commerciale cachée — la raison, l’heure et
        l’audit sont visibles.
      </p>
    </div>
  )
}
